import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  declare menuTarget: HTMLElement

  toggle(): void {
    this.menuTarget.classList.toggle("hidden")
  }

  hide(event: Event): void {
    if (!this.element.contains(event.target as Node)) {
      this.menuTarget.classList.add("hidden")
    }
  }

  connect(): void {
    document.addEventListener("click", this.outsideClick)
  }

  disconnect(): void {
    document.removeEventListener("click", this.outsideClick)
  }

  private outsideClick = (event: Event): void => this.hide(event)
}
